import React, { useEffect, useRef, useState } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import withFeatureToggling from '../withFeatureToggling/withFeatureToggling';
import { HCAPTCHA } from 'constants/featureFlagging';
import { CaptchaBrandingInfo } from 'components/captchaBrandingInfo/CaptchaBrandingInfo';
import { ERROR_CAPTCHA } from 'constants/analyticsErrors';
import { withErrorViewNavigation } from '../withErrorViewNavigation/withErrorViewNavigation';

export const withHCaptcha = WrappedComponent => {
    const HCaptchaWrapper = ({ flags, goToErrorsView, ...props }) => {
        const isHCaptchaActived = flags.get(HCAPTCHA);
        const captchaRef = useRef(null);
        const callbackRef = useRef();
        const [hCaptchaToken, setHCaptchaToken] = useState(null);

        useEffect(() => {
            hCaptchaToken && callbackRef.current?.(hCaptchaToken);
        }, [hCaptchaToken]);

        if (!isHCaptchaActived) {
            return <WrappedComponent {...props} />;
        }

        const readyHCaptchaToken = callback => {
            if (!isHCaptchaActived) {
                callback();

                return;
            }

            callbackRef.current = callback;
            captchaRef.current.execute();
        };

        const handleTokenError = () => {
            goToErrorsView({ errorMessage: ERROR_CAPTCHA });
        };

        const renderHCaptchaTermsAndConditions = () => {
            return <CaptchaBrandingInfo active={isHCaptchaActived} text={'validation-hCaptcha'} />;
        };

        return (
            <>
                <WrappedComponent
                    {...props}
                    readyHCaptchaToken={readyHCaptchaToken}
                    isHCaptchaActive={isHCaptchaActived}
                    renderHCaptchaTermsAndConditions={renderHCaptchaTermsAndConditions}
                />
                <HCaptcha
                    size="invisible"
                    sitekey={__HCAPTCHA_SITEKEY__}
                    onVerify={setHCaptchaToken}
                    ref={captchaRef}
                    onError={handleTokenError}
                />
            </>
        );
    };

    return withErrorViewNavigation(withFeatureToggling(HCaptchaWrapper));
};
